import {
	removeError,
	scrollToFirstError,
	initPassportSeriesInput,
	validatePassportSeriesValue,
	initPassportNumberInput,
	validatePassportNumberValue,
	addError
} from '../lib/forms';

let form,
	passportSeriesInput,
	passportNumberInput;


const init = () => {
	form = document.querySelector('.js-parent-profile-form');
	if (!form) return;

	passportSeriesInput = form.querySelector('#profile-passport-series');
	if (passportSeriesInput) {
		initPassportSeriesInput(passportSeriesInput);

		if (passportSeriesInput.mask) {
			passportSeriesInput.mask.on('accept', function() {
				if (validatePassportSeriesValue(passportSeriesInput)) {
					removeError(passportSeriesInput);
				}
			});
		}
	}

	passportNumberInput = form.querySelector('#profile-passport-number');
	if (passportNumberInput) {
		initPassportNumberInput(passportNumberInput);

		if (passportNumberInput.mask) {
			passportNumberInput.mask.on('accept', function() {
				if (validatePassportNumberValue(passportNumberInput)) {
					removeError(passportNumberInput);
				}
			});
		}
	}

	// submit
	form.addEventListener('submit', (e) => {
		let hasErrors = false;

		if (passportSeriesInput && passportSeriesInput.mask) {
			removeError(passportSeriesInput);

			if (!validatePassportSeriesValue(passportSeriesInput)) {
				addError(passportSeriesInput);
				hasErrors = true;
			}
		}

		if (passportNumberInput && passportNumberInput.mask) {
			removeError(passportNumberInput);

			if (!validatePassportNumberValue(passportNumberInput)) {
				addError(passportNumberInput);
				hasErrors = true;
			}
		}

		if (hasErrors) {
			scrollToFirstError(form);
			e.preventDefault();
		}

		return hasErrors === false;
	});
};

export default {
	init
};